"use strict";

exports.__esModule = true;
exports.PolkadotAdapter = exports.KusamaAdapter = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _errors = require("../../wallet/errors");
var _rxjs = require("rxjs");
var _polkadot = require("../balance-adapter/polkadot");
var _baseChainAdapter = require("../base-chain-adapter");
var _chains = require("../configs/chains");
const crossChainFeeConfigs = {
  KSM: '106666660',
  DOT: '106666660'
};
class BasePolkadotAdapter extends _baseChainAdapter.BaseCrossChainAdapter {
  constructor(configs, chain, routers) {
    super(configs.api, chain, routers);
    this.balanceAdapter = void 0;
    this.balanceAdapter = new _polkadot.PolkadotBalanceAdapter({
      api: configs.api
    });
  }
  subscribeAvailableBalance(token, address) {
    return this.balanceAdapter.subscribeBalance(token, address).pipe((0, _rxjs.map)(i => i.available));
  }
  subscribeMaxInput(token, address, to) {
    return (0, _rxjs.combineLatest)({
      txFee: this.measureTransferFee({
        amount: _sdkCore.FixedPointNumber.ZERO,
        to,
        token,
        address
      }),
      balance: this.balanceAdapter.subscribeBalance(token, address).pipe((0, _rxjs.map)(i => i.available))
    }).pipe((0, _rxjs.map)(_ref => {
      let {
        txFee,
        balance
      } = _ref;
      const feeFactor = 1.2;
      const fee = _sdkCore.FixedPointNumber.fromInner(txFee, this.balanceAdapter.decimals).mul(new _sdkCore.FixedPointNumber(feeFactor));
      const ed = this.balanceAdapter.getED();

      // always minus ed
      return balance.minus(fee).minus(ed);
    }));
  }
  subscribeMinInput(token) {
    var _this$getCrossChainFe;
    return (0, _rxjs.of)(this.balanceAdapter.getED(token).add(((_this$getCrossChainFe = this.getCrossChainFee(token)) === null || _this$getCrossChainFe === void 0 ? void 0 : _this$getCrossChainFe.balance) || _sdkCore.FixedPointNumber.ZERO));
  }
  getCrossChainFee(token) {
    var _crossChainFeeConfigs;
    return {
      token: 'KSM',
      balance: _sdkCore.FixedPointNumber.fromInner((_crossChainFeeConfigs = crossChainFeeConfigs[token]) !== null && _crossChainFeeConfigs !== void 0 ? _crossChainFeeConfigs : '0', this.balanceAdapter.decimals)
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getCrossChainTokenDecimals(_token) {
    // ignore the token params for only KSM/DOT
    return this.balanceAdapter.decimals;
  }
  createTx(params) {
    const {
      to,
      token,
      address,
      amount
    } = params;
    const toChain = _chains.chains[to];
    if (token !== this.balanceAdapter.nativeToken) throw new _errors.CurrencyNotFound(token);
    const accountId = this.api.createType('AccountId32', address).toHex();
    const tx = this.api.tx.xcmPallet.reserveTransferAssets;
    const dst = {
      X1: {
        ParaChain: toChain.paraChainId
      },
      parents: 0
    };
    const acc = {
      X1: {
        AccountId32: {
          id: accountId,
          network: 'Any'
        }
      }
    };
    const ass = [{
      ConcreteFungible: {
        amount: amount.toChainData()
      }
    }];
    const callParams = [{
      V0: dst
    }, {
      V0: acc
    }, {
      V0: ass
    }, 0];
    return tx(...callParams);
  }
}
class PolkadotAdapter extends BasePolkadotAdapter {
  constructor(configs) {
    super(configs, _chains.chains.polkadot, [{
      to: _chains.chains.acala,
      token: 'DOT'
    }]);
  }
}
exports.PolkadotAdapter = PolkadotAdapter;
class KusamaAdapter extends BasePolkadotAdapter {
  constructor(configs) {
    super(configs, _chains.chains.kusama, [{
      to: _chains.chains.karura,
      token: 'KSM'
    }]);
  }
}
exports.KusamaAdapter = KusamaAdapter;